import React from 'react'

export default function ErrorMessage({ message }) {
  return (
    <div className="w-full bg-red-400 text-gray_1 font-semibold text-center p-1">{message}</div>
  )
}
